import BillingSummary from './BillingSummary/BillingSummary';
import BillingSummaryPage from './BillingSummaryPage/BillingSummaryPage';
import InvoicesTable from './InvoicesTable/InvoicesTable';
import MakePaymentPage from './MakePaymentPage/MakePaymentPage';
import PaymentPlans from './PaymentPlans/PaymentPlansComponent'; 
import TurnOnAutopay from './TurnOnAutopay/TurnOnAutopayComponent'; 
import PaymentMethod from './PaymentMethod/PaymentMethodComponent'; 
import SetupAutomaticPaymentComponent from './SetupAutomaticPayment/SetupAutomaticPaymentComponent';
import MakeAPayment from './MakeAPayment/MakeAPaymentComponent'; 
import ManagePaymentMethodsPage from './ManagePaymentMethodsPage/ManagePaymentMethodsPage';
import AccountConfirmationPopup from './AccountConfirmationPopup/AccountConfirmationPopup';
 import { PaymentContext } from './PaymentContext/PaymentContextProvider';

const billingComponentMap = {
    InvoicesTable: { component: 'InvoicesTable' },
    BillingSummary: { component: 'BillingSummary' },
    AccountConfirmationPopup: {component: 'AccountConfirmationPopup'},
    // SetupAutomaticPaymentComponent: {component: 'SetupAutomaticPaymentComponent'}
};

const billingAdditionalComponents = {
    InvoicesTable,
    BillingSummary,
    AccountConfirmationPopup,
    // SetupAutomaticPaymentComponent
};

export {
    InvoicesTable,
    BillingSummary,
    BillingSummaryPage,
    MakePaymentPage,
    billingComponentMap,
    billingAdditionalComponents,
    PaymentPlans,
    TurnOnAutopay,
    PaymentMethod,
    MakeAPayment,
    SetupAutomaticPaymentComponent,
    ManagePaymentMethodsPage,
    AccountConfirmationPopup,
     PaymentContext,
};
